import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-worktype-form',
  templateUrl: './worktype-form.component.html',
  styleUrls: ['./worktype-form.component.css']
})
export class WorktypeFormComponent implements OnInit {

  title="Add Type of Work";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/master/work-type/worktype-form/worktype-form.component.ts